import React, { useEffect } from "react";
import useAuth from "../components/auth/useAuth";
import BioMarkersMetabolic from "./biomarkers/biomarker-metabolic";
import BioMarkersNeuro from "./biomarkers/biomarker-neuro";
import BioMarkersCardio from "./biomarkers/biomarker-cardio";
import BioMarkersHormonal from "./biomarkers/biomarker-hormonal";
import BioMarkersEnviron from "./biomarkers/biomarker-environ";
import BioMarkersAging from "./biomarkers/biomarker-aging";
import { summarizeCounts } from "./biomarkers/countSummary";

const BioMarkers = () => {
  const { isAuthenticated, redirectToAuth, loading } = useAuth();
  
  useEffect(() => {
    if (!loading && !isAuthenticated) {
      console.warn("User not authenticated. Redirecting...");
      redirectToAuth();
    }
  }, [isAuthenticated, loading, redirectToAuth]);

  // Add smooth scrolling functionality
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return null;
  }

  // const MainDisplay = () => {
    const totalCounts = summarizeCounts();
    console.log('Total Counts', totalCounts);
  

  return (
    <div className="section" id="bio-markers">
      <h2>Bio Markers</h2>
      <p>Below is a comprehensive set of biomarkers, where the complex human systems are distilled into essential categories aimed at promoting longevity and enhancing interventions against disease.</p>
      <p>In this representation it is important to avoid the traditional medicine approach which often focuses on boundaries which only addresses biomarkers when they cross thresholds of concern. The legacy boundary approach is like waiting until you touch an electric fence before making adjustments. Instead, this new approach similar to how it would be addressed in cybersecurity takes a preventative and proactive stance by focusing on optimal targets.</p>
      
      {/* Navigation links section */}

<div className="latest-updates-fixes-bio">
  <p>
    <strong>Total BioMarkers</strong>
    <span className="info-icon-bio" >
      i
      <span className="tooltip">
      By identifying the ideal biomarker ranges tailored to your body.  This approach aims to guide your health toward precision and longevity, prioritizing prevention over reaction.
      </span>
    </span>
  </p>

  {/* Total Biomarkers */}
  <div className="metric">
    <span style={{ color: "#F1E0C5" }}>{totalCounts.totalMarkers}</span> Biomarkers
  </div>

  {/* Progress bar */}
  <div className="progress-container">
    <div
      className="progress-bar"
      style={{
        width: `${
          totalCounts.totalMarkers > 0
            ? ((totalCounts.totalMarkers - totalCounts.notMeasured) / totalCounts.totalMarkers) * 100
            : 0
        }%`
      }}
    ></div>
  </div>
  <div className="progress-labels">
    <span style={{ color: "#d4d4d4" }}>
      {totalCounts.totalMarkers - totalCounts.notMeasured} Measured
    </span>
    <span style={{ color: "#888" }}>{totalCounts.notMeasured} Not Measured</span>
  </div>

  {/* Breakdown */}
    <div className="counters">
      <div className="counter-item" style={{ color: "#77b300" }}>
        {totalCounts.greenCount} On Target
      </div>
      <div className="counter-item" style={{ color: "#7db7eeff" }}>
        {totalCounts.targetRange} In Range
      </div>
      <div className="counter-item" style={{ color: "#CA2C29" }}>
        {totalCounts.redFlags} Red Flags
      </div>
      <div className="counter-item" style={{ color: "#888" }}>
        {totalCounts.notMeasured} Not Measured
      </div>
    </div>
    </div>


      <div className="card-container">
      {/* <div className="latest-updates-fixes">
          <p><strong>Metabolic & Immunity Markers</strong></p>
          <span className="info-icon">i
            <span className="tooltip">This system focuses on energy production, metabolic efficiency, and cellular resilience. It encompasses the digestive, immune/lymphatic, and renal systems, ensuring nutrient absorption, toxin elimination, and inflammation control. Key factors include mitochondrial function, insulin sensitivity, and cellular repair mechanisms.</span>
          </span>
      </div> */}

          <button onClick={() => scrollToSection("metabolic-markers")} className="card-container-button">
          Metabolic Markers
          </button>
          <button onClick={() => scrollToSection("neuro-markers")} className="card-container-button">
            Neuro Markers
          </button>
          <button onClick={() => scrollToSection("aging-markers")} className="card-container-button">
            Aging & DNA Markers
          </button>
          <button onClick={() => scrollToSection("cardio-markers")} className="card-container-button">
            Cardio Markers
          </button>
          <button onClick={() => scrollToSection("hormonal-markers")} className="card-container-button">
            Hormonal Markers
          </button>
          <button onClick={() => scrollToSection("environ-markers")} className="card-container-button">
            Environmental Markers
          </button>
        {/* </div> */}
      </div>

      {/* <div className="card-container">
        <h3>Total Markers: {totalCounts.totalMarkers}</h3>
        <h3>Not Measured: {totalCounts.notMeasured}</h3>
        <h3>Red Flags: <span style={{ color: "#ff3300" }}>{totalCounts.redFlags}</span></h3>
        <h3>Within Range: {totalCounts.targetRange}</h3>
        <h3>On Target: <span style={{ color: "#77b300" }}>{totalCounts.greenCount}</span></h3>
      </div> */}
      <hr className="custom-line" />
      
      <div id="metabolic-markers">
        <BioMarkersMetabolic />
      </div>
      <div id="neuro-markers">
        <BioMarkersNeuro />
      </div>
      <div id="aging-markers">
        <BioMarkersAging />
      </div>
      <div id="cardio-markers">
        <BioMarkersCardio />
      </div>
      <div id="hormonal-markers">
        <BioMarkersHormonal />
      </div>
      <div id="environ-markers">
        <BioMarkersEnviron />
      </div>
    </div>
  );
};

export default BioMarkers;
